module.exports = __webpack_public_path__ + "static/media/Fjelltur_Skottland.a01bfcfe.png";